import api from '../api'; // import your configured axios instance
import { API_URL } from '../config';

// GET all leave requests tracking
export const  getAllLeaveTrackers = async () => {
  const response = await api.get(`${API_URL}/progress-tracker/leave`);
  return response.data;
};

// GET all leave requests tracking
export const  getAllAbsenceTrackers = async () => {
  const response = await api.get(`${API_URL}/progress-tracker/absence`);
  return response.data;
};

export const  getAllConvertedAbsenceTrackers = async () => {
  const response = await api.get(`${API_URL}/progress-tracker/converted-absence-leave`);
  return response.data;
};

export const getByTitle = async (title) => {
  const response = await api.get(`${API_URL}/progress-tracker`, {
    params: { title }
  });
  return response.data;
};


